import React, { createContext, useState, useContext, useEffect } from 'react';

const LocalizationContext = createContext();

export const LocalizationProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {

      if(['en', 'es', 'se', 'de'].includes(navigator.language.substring(0,2)))
          return navigator.language.substring(0,2);
      else return 'en'
  });

  const setterLanguage = (lang) => {
      console.error("Do not change the language unless you have a language button!")
  }

  return (
    <LocalizationContext.Provider value={{ language, setLanguage: setterLanguage }}>
      {children}
    </LocalizationContext.Provider>
  );
};

export const useLocalization = () => useContext(LocalizationContext);

export const LocalizationConsumer = LocalizationContext.Consumer;
